import React from 'react';

export default function ShuffleIcon(props) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 18 16" version="1.1" {...props} className="controls__icon">
      <path d="M13.584,4.653L14.746,4.653L14.746,6.529L18,3.229L14.746,0L14.746,2.142L13.584,2.142C10.262,2.142 8.385,4.597 6.73,6.763C5.243,8.71 3.958,10.547 1.884,10.547L0,10.547L0,13.057L1.884,13.057C5.207,13.057 7.083,10.447 8.739,8.282C10.225,6.334 11.507,4.653 13.584,4.653ZM4.87,6.088C5.01,5.906 5.155,5.719 5.3,5.529C5.653,5.069 6.023,4.581 6.425,4.097C5.235,2.991 3.801,2.174 1.884,2.174L0,2.174L0,4.684C0,4.684 0.534,4.66 1.884,4.684C3.19,4.712 4.01,5.244 4.87,6.088ZM14.746,10.566L13.584,10.566C12.319,10.566 11.346,9.94 10.442,9.008C10.354,9.127 10.262,9.246 10.169,9.365C9.771,9.884 9.346,10.443 8.875,10.995C10.097,12.181 11.575,13.077 13.584,13.077L14.746,13.077L14.746,15.231L18,12.002L14.746,8.702L14.746,10.566Z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/vectors/ShuffleIcon.js